import GridLoader from "react-spinners/GridLoader";

const FullScreenLoader = () => {
  return (
    <div className="fixed inset-0 z-5000 flex items-center justify-center bg-black bg-opacity-10 backdrop-blur-[1px]">
      <GridLoader color="#1f3260" />
    </div>
  );
};

export default FullScreenLoader;
